export const aboutSections = [
  {
    id: 1,
    title: "ABOUT",
    icon: "🟡",
    paragraphs: [
      "This page <span>will help you remember</span> a new phrase or word using the 90 seconds technique.",
      "You just need to add sentences to memorize to your list and <span>just read the phrase according to the schedule</span>.",
      "HINTS:",
    ],
    list: [
      "add a folder to order your phrases list.",
      "select a part of your phrase to highlight it during training.",
      "add a note to have a pop-up during training.",
      "learn at your own pace — add phrases to the queue for gradual automatic activation.",
    ],
  },
  {
    id: 2,
    title: "STRATEGY",
    paragraphs: [
      "When you see a new expression, <span>write it down</span> in your notes.",
      "<span>Give it some context.</span> Don’t just write the translation.",
      "Write down the phrase you saw or heard in a sentence.",
      "This way, you’ll capture useful details (prepositions, articles, word order, etc.) and, most importantly, be able to use it when needed.",
    ],
  },
  {
    id: 3,
    title: "INSTRUCTIONS",
    list: [
      "For 7 days, read each expression out loud twice a day. <span>You must not skip more than 3 consecutive days.</span>",
      "1 week later, and then 2 weeks later, read it out loud again (3 times each). <span>You must not skip more than 3 consecutive days at any stage.</span>",
      "70 + 10 + 10 = 90 seconds. <span>It takes 10 seconds to read a phrase.</span>",
      "<span>If you exceed the allowed breaks, just start again!</span>",
    ],
  },
  {
    id: 4,
    title: "TIPS",
    paragraphs: [
      "Don’t force yourself to memorize an expression.",
      "Just <span>focus</span> on it and understand what you’re saying.",
      "<span>Read</span> an expression <span>out loud</span>, emotionally and clearly.",
      "This helps cement the expression in your memory.",
    ],
  },
];
export const aboutCards = [
  {
    id: 1,
    title: "ABOUT THE APP",
    icon: "🟡",
    short: [
      "This page <span>will help you remember</span> a new phrase or word using the 90 seconds technique.",
    ],
    long: [
      "You just need to add sentences to memorize to your list and <span>just read the phrase according to the schedule</span>.",
    ],
    list: [
      "add phrases to memorize to your list",
      "select a part of your phrase to highlight it during training",
      "add a note to have a pop-up during training",
      "add a folder to order your phrases list",
      "learn at your own pace — add phrases to the queue for gradual automatic activation",
    ],
  },
  {
    id: 2,
    title: "INSTRUCTIONS",
    short: ["Write down the phrase you saw or heard in a sentence."],
    long: [
      "This way, you’ll capture useful details (prepositions, articles, word order, etc.) and, most importantly, be able to use it when needed.",
    ],
    list: [
      "When you see a new expression, <span>write it down</span> in your notes.",
      "<span>Give it some context.</span>",
      "Don’t just write the translation.",
    ],
  },
  {
    id: 3,
    title: "PLAN",
    short: ["Follow special plan"],
    long: ["You must not skip more than 3 consecutive days at any stage."],
    list: [
      "For 7 days, read each expression out loud twice a day.",
      "1 week later read it out loud again (3 times each).",
      "2 week later read it out loud again (3 times each).",
      "70 + 10 + 10 = 90 seconds. <span>It takes 10 seconds to read a phrase.</span>",
      "<span>If you exceed the allowed breaks, just start again!</span>",
    ],
  },
  {
    id: 4,
    title: "TIPS",
    short: [
      "<span>Read</span> an expression <span>out loud</span>, emotionally and clearly.",
    ],
    list: [
      "Don’t force yourself to memorize an expression.",
      "Just <span>focus</span> on it and understand what you’re saying.",
      "This helps cement the expression in your memory.",
    ],
  },
];
export const shortInstructions = [
  "Add a word to your list",
  "Read it according to the plan",
  "Spend only 90 seconds of your time",
];
